import { GenericDatabase } from './GenericDatabase'

const DB_NAME = 'Executions'
const DB_VERSION = 3
const STORE_NAME = 'Reports'
const SYNC_QUEUE_STORE = 'SyncQueue'

const dbInstance = new GenericDatabase(
    DB_NAME,
    DB_VERSION,
    [
        {
            name: STORE_NAME,
            keyPath: '_id',
            indices: [
                { name: 'reportId', keyPath: 'reportId', options: { unique: false } }
            ]
        },
        {
            name: SYNC_QUEUE_STORE,
            keyPath: 'id',
            indices: [
                { name: 'status', keyPath: 'status', options: { unique: false } },
                { name: 'reportId', keyPath: 'reportId', options: { unique: false } }
            ]
        }
    ],
    [
        {
            fromVersion: 1,
            toVersion: 2,
            migrate: (db, tx) => {
                const store = tx.objectStore(STORE_NAME)
                if (!store.indexNames.contains('reportId')) {
                    store.createIndex('reportId', 'reportId', { unique: false })
                }
            }
        },
        {
            fromVersion: 2,
            toVersion: 3,
            migrate: (db, tx) => {
                if (!db.objectStoreNames.contains(SYNC_QUEUE_STORE)) {
                    db.createObjectStore(SYNC_QUEUE_STORE, { keyPath: 'id' })
                }
                const store = tx.objectStore(SYNC_QUEUE_STORE)
                if (!store.indexNames.contains('status')) {
                    store.createIndex('status', 'status', { unique: false })
                }
                if (!store.indexNames.contains('reportId')) {
                    store.createIndex('reportId', 'reportId', { unique: false })
                }
            }
        }
    ]
)

const initDb = () => {
    return dbInstance.init()
}

const agregar = (data) => {
    return dbInstance.upsert(STORE_NAME, data)
}

const obtener = async (clave) => {
    // Original called initDb internally.
    return dbInstance.get(STORE_NAME, clave)
}

const actualizar = async (data) => {
    // Original called initDb internally.
    return dbInstance.put(STORE_NAME, data)
}

const eliminar = (clave) => {
    // Removed 'database' param as it's handled internally
    return dbInstance.delete(STORE_NAME, clave)
}

const consultar = async (clave) => {
    const result = await dbInstance.getByIndex(
        STORE_NAME,
        'reportId',
        clave?.toString()
    )
    return result || null
}

const consultarTodas = async () => {
    // Original called initDb internally.
    return dbInstance.getAll(STORE_NAME)
}

// --- Sync Queue operations ---

const guardarItemSync = (item) => {
    return dbInstance.upsert(SYNC_QUEUE_STORE, item)
}

const obtenerItemsSyncPendientes = async () => {
    const all = await dbInstance.getAll(SYNC_QUEUE_STORE)
    return all.filter(
        (item) => item.status === 'pending' || item.status === 'processing'
    )
}

const actualizarItemSync = async (id, updates) => {
    const item = await dbInstance.get(SYNC_QUEUE_STORE, id)
    if (!item) return false
    return dbInstance.put(SYNC_QUEUE_STORE, {
        ...item,
        ...updates,
        updatedAt: Date.now()
    })
}

const eliminarItemSync = (id) => {
    return dbInstance.delete(SYNC_QUEUE_STORE, id)
}

const limpiarItemsCompletados = async () => {
    const all = await dbInstance.getAll(SYNC_QUEUE_STORE)
    const stale = all.filter((item) => {
        if (item.status === 'completed' && item.updatedAt) {
            return Date.now() - item.updatedAt > 86400000 // 24h
        }
        if (item.status === 'failed' && item.retryCount > 3) {
            return true
        }
        return false
    })
    await Promise.all(
        stale.map((item) => dbInstance.delete(SYNC_QUEUE_STORE, item.id))
    )
    return stale.length
}

export default {
    initDb,
    agregar,
    obtener,
    actualizar,
    eliminar,
    consultar,
    consultarTodas,
    guardarItemSync,
    obtenerItemsSyncPendientes,
    actualizarItemSync,
    eliminarItemSync,
    limpiarItemsCompletados
}
